// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1s8bI","summary":"R_R6L"};